import styled from "styled-components";

export const Container = styled.main`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgb(0,0,0, 0.2);
    z-index: 1000;
    
    display: flex;
    align-items: center;
    justify-content: center;

    pointer-events: none; // This allows clicks to pass through to elements below
  
    & > * {
        pointer-events: auto; // But content inside the container will still receive clicks
    }
`;

export const Content = styled.div<{isStatic: boolean}>`
    position: absolute;

    background-color: ${(props) => props.theme.colors.white};
    width: 600px;
    padding: 30px;
    border-radius: 4px;
    
    display: flex;
    flex-direction: column;
    gap: 20px;

    &:active {
        cursor: grabbing;
    }

    @media (max-width: 900px) {
        position: static;
        padding: 20px;
        width: 100%;
        max-width: 95%;
        max-height: 95%;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    svg{
        color: ${(props) => props.theme.colors.gray.gray_600};
    }

    cursor: grab; /* Indica que o cabeçalho é arrastável */
`;

export const infor = styled.div`
`;

export const Title = styled.p`
    font-size: 24px;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
`;

export const SubTitle = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 14px;
`;

export const ContentButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    svg{
        cursor: pointer;
    }
`;

export const Footer = styled.footer`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    div{
        display: flex;
        gap: 10px;
    }
`;

export const ContentMinimize = styled.div`
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 10000;

    padding: 8px;
    border-radius: 30px;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 2px 2px 4px 0px ${(props) => props.theme.colors.gray.gray_200};
    color: ${(props) => props.theme.colors.primary};
    font-weight: 500;
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }

    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
`;